import React, { FC, ReactElement } from "react"
import { FieldArray, FormikProps } from "formik" // eslint-disable-line

import TrashIcon from "../../../assets/icons/trash-icon.svg"
import { TenantConfigData } from "../../../types/api"
import { InputField } from "../../inputs/InputField"

export const SealsFields: FC = (): ReactElement => (
  <FieldArray
    name="seals"
    render={({ form, push, remove }) => (
      <div className="mt-5 pb-4 border-b border-gray-400">
        <h4>Seals</h4>
        {(form as FormikProps<TenantConfigData>).values.seals.map((_, index) => {
          return (
            <div key={index} className="flex items-end gap-2">
              <span className="mb-3">{index + 1}</span>
              <div className="grow">
                <InputField
                  name={`seals.${index}.type`}
                  value={(form as FormikProps<TenantConfigData>).values.seals[index].type}
                  onChange={form.handleChange}
                  title="Type"
                  placeholder="e.g. anj"
                />
              </div>
              <div className="grow">
                <InputField
                  name={`seals.${index}.id`}
                  value={(form as FormikProps<TenantConfigData>).values.seals[index].id}
                  onChange={form.handleChange}
                  title="Seal ID"
                  placeholder="e.g. 5c5439bf-5a01-4bfd-937a-785fa16bc7f3"
                />
              </div>
              <button className="mb-3" onClick={() => remove(index)} type="button">
                <img className="w-5 h-5" src={TrashIcon} alt="Trash icon" />
              </button>
            </div>
          )
        })}
        <button type="button" onClick={() => push({ type: "", id: "" })} className="btn btn-success mt-4">
          Add seal
        </button>
      </div>
    )}
  />
)
